import { render } from "./BrowseAllProducts.vue?vue&type=template&id=5c11f546&scoped=true&ts=true"
import script from "./BrowseAllProducts.vue?vue&type=script&lang=ts"
export * from "./BrowseAllProducts.vue?vue&type=script&lang=ts"

import "./BrowseAllProducts.vue?vue&type=style&index=0&id=5c11f546&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c11f546"]])

export default __exports__